import { createElement } from 'react';
import Table from 'antd/lib/table';
import { cloneDeep, merge } from 'lodash';
function handleColumns(columns, dataSource, onHeaderCell, onCell) {
    const list = cloneDeep(columns);
    let row0 = {};
    if (Array.isArray(dataSource) && dataSource.length) {
        row0 = dataSource[0];
    }
    let keysRow = Object.keys(row0).filter((key) => key && !key.startsWith('__'));
    for (const item of list) {
        const { dataIndex, title, width } = item;
        if (dataIndex && dataIndex.includes('__*')) {
            const oneLevelLabel = dataIndex.split('__')[0];
            if (!title) {
                item.title = oneLevelLabel;
            }
            const childList = [];
            const targetKeyList = keysRow.filter((key) => key.startsWith(`${oneLevelLabel}__`));
            for (const childItem of targetKeyList) {
                const childLabel = childItem.split('__')[1];
                const childRow = {
                    title: childLabel,
                    key: childItem,
                    dataIndex: childItem,
                    width: width || 120,
                    onHeaderCell,
                };
                childRow.onCell = (record, rowIndex) => {
                    return handleOnCell.call(this, record, rowIndex, childRow, onCell);
                };
                childList.push(childRow);
            }
            item.children = childList;
            keysRow = keysRow
                .filter((key) => {
                return !targetKeyList.includes(key);
            })
                .filter((key) => key);
        }
    }
    const resetPropIndex = list.findIndex((item) => item.dataIndex === '*');
    const resetListProp = [];
    if (resetPropIndex !== -1) {
        keysRow.forEach((key) => {
            const isExit = list.some((item) => item.dataIndex === key);
            if (!isExit) {
                const column = {
                    title: key,
                    dataIndex: key,
                };
                resetListProp.push({
                    title: key,
                    key: key,
                    dataIndex: key,
                    width: list[resetPropIndex].width,
                    onHeaderCell: onHeaderCell.bind(this, column),
                    onCell: (record, rowIndex) => {
                        return handleOnCell.call(this, record, rowIndex, column, onCell);
                    }
                });
            }
        });
        list.splice(resetPropIndex, 1, ...resetListProp);
    }
    return list.filter((item) => !item.hidden);
}
function dealStyleConfig(dataStyle) {
    if (dataStyle) {
        return typeof dataStyle === 'string' ? JSON.parse(dataStyle) : dataStyle;
    }
    else {
        return {};
    }
}
function handleOnCell(record, rowIndex, column, onCell) {
    const { dataIndex } = column;
    const cellStyle = dealStyleConfig(record[`_styleCellSetting_${dataIndex}`]);
    const res = onCell.call(this, record, rowIndex, column);
    return merge({ style: cellStyle }, res);
}
const HhTable = ({ columns, dataSource = [], events, onHeaderCell = () => { }, onCell = () => { }, ...otherProps }) => {
    console.log(events);
    const _columns = handleColumns(columns, dataSource, onHeaderCell, onCell);
    _columns.forEach((column) => {
        column.onHeaderCell = onHeaderCell.bind(this, column);
        column.onCell = (record, rowIndex) => {
            return handleOnCell.call(this, record, rowIndex, column, onCell);
        };
    });
    return createElement(Table, { dataSource: dataSource, columns: _columns, ...otherProps });
};
export default HhTable;
